import { render, staticRenderFns } from "./new1.vue?vue&type=template&id=5ccd5f4c"
import script from "./new1.vue?vue&type=script&lang=js"
export * from "./new1.vue?vue&type=script&lang=js"
import style0 from "./new1.vue?vue&type=style&index=0&id=5ccd5f4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports